'use strict';

function controller ($scope) {
    let ctrl = this;
    let previousRating;
    ctrl.notApplicable = {};
    ctrl.stars = [];

    ctrl.$onInit = function () {

        if (!ctrl.rating && ctrl.boundRating) {
            ctrl.rating = ctrl.boundRating;
        }

        ctrl.showRating = !(ctrl.rating == 0 && !ctrl.clickable && ctrl.icon == 'bar');

        ctrl.notApplicable.filled = (ctrl.boundRating == '0') ? true : false;
        ctrl.icon = ctrl.icon || "star";
        ctrl.rating = ctrl.rating || "0";
        ctrl.starHeight = ctrl.starHeight || 1.5;
        ctrl.showCount = (typeof ctrl.showCount === 'undefined') ? 'true' : ctrl.showCount;
        ctrl.stars = ctrl.calcStars(+ctrl.rating); // Coerce ctrl.rating into a string
        if (!ctrl.reviewsUrl && ctrl.dealerId) {
            ctrl.reviewsUrl = `/dealers/${ctrl.dealerId}/#Reviews`;
        }

        ctrl.ratingLabel = ctrl.buildLabel(ctrl.reviews, ctrl.rating);

        ctrl.dealerRatingAlsClickThruObj = {
            pageToId: ctrl.webPageTypeToId,
            pageFromId: ctrl.webPageTypeFromId,
            listingId: ctrl.listingId,
            sellerId: ctrl.partyId
        };

    };

    ctrl.buildStarClass = function(index) {
        return 'star-' + ctrl.stars[index] + '-perc';
    };

    ctrl.starClick = function(rating){
        if ( ctrl.clickable == true ) {

            ctrl.notApplicable.filled = (rating == 0) ? true : false;
            ctrl.stars = ctrl.calcStars(+rating);

            previousRating = ctrl.boundRating;

            ctrl.boundRating = rating;
        }
    };

    ctrl.zeroClick = function () {
        if (ctrl.boundRating === 0) {
            ctrl.starClick(previousRating);
        } else {
            ctrl.starClick(0);
        }
    };

    ctrl.calcStars = function (rating) {

        var stars = [],
            roundedRating = Math.round(rating * 2) / 2,
            fullStars = Math.floor(roundedRating),
            partialStar = roundedRating - fullStars;

        for (let n = 0; n < 5; n++) {
            if (n < fullStars) {
                stars.push(100);
            } else if (n === fullStars  && partialStar !== 0) {
                stars.push(partialStar * 100);
            } else {
                stars.push(0);
            }
        }

        return stars;
    };

    ctrl.buildLabel = function (reviews, rating) {
        let label;

        reviews = parseInt(reviews, 10);
        //rating = parseFloat(rating);
        //
        //if (featureFlagsService.get('dealerRaterIntegration')) {
        //    if (reviews > 0 && rating > 0) {
        //        if (reviews == 1) {label = '1 review';}
        //        if (reviews > 1) {label = reviews + ' reviews';}
        //    } else if (reviews > 0 && rating === 0) {
        //        label = "0 recent reviews";
        //    } else {
        //        label = "No reviews";
        //    }
        //} else {
            if (reviews == 0) {label = 'No reviews';}
            if (reviews == 1) {label = '1 review';}
            if (reviews > 1) {label = reviews + ' reviews';}
        //}

        return label;
    };

    ctrl.updateRating = function () {
        ctrl.stars = ctrl.calcStars(+ctrl.rating);
    };

    $scope.$watchGroup(['rating'], ctrl.updateRating);

}
controller.$inject = ['$scope'];

export default controller;
